// extracted by mini-css-extract-plugin
export default {"main":"Pagination_main__pE25u"};